import { FieldPath, FieldValues } from "react-hook-form";

export const getDirtyFieldNames = <TFieldValues extends FieldValues>(
  dirtyFields: Partial<Record<keyof TFieldValues, any>>,
): FieldPath<TFieldValues>[] => {
  const fields: FieldPath<TFieldValues>[] = [];

  const extractNames = (
    fieldsObject: Partial<Record<string, any>>,
    currentPath: string = '',
  ) => {
    Object.keys(fieldsObject).forEach((key) => {
      const field = fieldsObject[key];
      const newPath = currentPath ? (`${currentPath}.${key}` as FieldPath<TFieldValues>) : (key as FieldPath<TFieldValues>);

      if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
        extractNames(field, newPath);
      } else if (Array.isArray(field)) {
        field.forEach((item, index) => {
          if (item && typeof item === 'object' && !Array.isArray(item)) {
            const arrayPath = `${newPath}.${index}`;

            extractNames(item, arrayPath);
          } else if (item === true) {
            fields.push(newPath);
          }
        });
      } else if (field === true) {
        fields.push(newPath);
      }
    });
  };

  extractNames(dirtyFields as Partial<Record<string, any>>);

  return fields;
};
